<template>
  <v-row>
    <v-col
      cols="12"
      md="12"
    >
      <v-card class="box card-cambio">
        <v-row class="pt-4">
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <v-autocomplete
              :label="$t('simulator.optionalCustomer')"
              :items="customerList"
              v-model="operation.customer"
              item-value="id"
              :item-text="itemTextCustomers"
              return-object
              dense
              clearable
              autofocus
              outlined
              v-disabled-icon-focus
              :filter="caseInsensitiveAccentsInsensitiveIgnoreDotsDashes"
              :loading="customerSearchLoading"
              :search-input.sync="customerSearchQuery"
              hide-no-data
              cache-items
              @click:clear="handleClearCustomer"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <v-autocomplete
              :label="$t('simulator.bankLabel')"
              :items="bankList"
              v-model="operation.bank"
              item-value="id"
              item-text="companyName"
              return-object
              dense
              clearable
              outlined
              v-disabled-icon-focus
              :rules="[validationIsRequiredAutocompleteId]"
            >
              <template #item="data">
                <v-row
                  no-gutters
                  class="py-2"
                >
                  <v-col>
                    <v-row no-gutters>
                      <v-col>
                        <span class="bank-title">{{ data.item.fantasyName }}</span>
                      </v-col>
                    </v-row>

                    <template v-if="operation.customer?.id">
                      <v-row no-gutters>
                        <v-col>
                          <span class="subtitle">
                            {{ $t('simulator.limitLabel') }} <b>{{ getLimitBank(data.item) }}</b>
                          </span>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col>
                          <span class="subtitle">
                            {{ $t('simulator.expiresLabel') }} <b>{{ getExpireBank(data.item) }}</b>
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <v-autocomplete
              :label="$t('simulator.natureLabel')"
              :items="natures"
              v-model="operation.nature"
              item-value="id"
              item-text="exibitionName"
              return-object
              dense
              clearable
              outlined
              v-disabled-icon-focus
              :rules="[validationIsRequiredAutocompleteId]"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <CurrencySelect
              :currency-list="currencies"
              v-model="operation.currency"
              :required="true"
            />
          </v-col>
          <v-col
            v-if="calculationTypeConst.CURRENCY_AMOUNT.id == calculationType"
            cols="12"
            class="py-0 mb-3"
          >
            <SimulatorValueSlider
              :amount="Number(operation.amount) || 0"
              :total-value="Number(operation.totalValue) || 0"
              :currency-code="operation.currency.code"
              @change="operation.amount = $event"
            />
          </v-col>
          <v-col
            v-if="calculationTypeConst.CURRENCY_AMOUNT.id == calculationType"
            cols="12"
            md="3"
            class="py-0"
          >
            <MoneyField
              :label="$t('simulator.currencyAmountLabel')"
              prefix=" "
              v-model="operation.amount"
              :rules="[validationIsRequiredFieldNumeric]"
              validate-on-blur
            />
          </v-col>
          <v-col
            v-else
            cols="12"
            md="3"
            class="py-0"
          >
            <MoneyField
              :label="$t('simulator.brlAmountLabel')"
              prefix=" "
              v-model="operation.totalValue"
              :rules="[validationIsRequiredFieldNumeric]"
              validate-on-blur
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <MoneyField
              :label="$t('simulator.spreadLabel')"
              prefix=" "
              suffix=" %"
              v-model="operation.spread"
              persistent-hint
              :hint="spreadHint"
              :min="operation.spreadMin"
              :max="operation.spreadMax"
              :rules="[validationIsRequiredFieldNumeric]"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <MoneyField
              :label="$t('simulator.customerRateLabel')"
              prefix="R$ "
              suffix=""
              :precision="operation.currency.precision"
              v-model="operation.customerRate"
              persistent-hint
              :hint="customerRateHint"
              :min="operation.customerRateMin"
              :max="operation.customerRateMax"
              :rules="[validationIsRequiredFieldNumeric]"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="py-0"
          >
            <MoneyField
              :label="$t('simulator.tariffLabel')"
              :prefix="tariffPrefix"
              suffix=""
              v-model="operation.exchangeContractCost"
              :rules="[validationIsRequiredFieldNumericAllowZero]"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="12"
      align="right"
      class="pb-0"
    >
      <v-card class="box card-cambio">
        <v-row class="pa-5">
          <v-col
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ $t('simulator.spotRateLabel') }}</h1>
            <span class="operation-value">{{
              operation.currencyQuotation || 0 | formatCurrency(operation.currency.precision)
            }}</span>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ iofLabel }}</h1>
            <span class="operation-value">{{ operation.iofValue || 0 | formatCurrency(2) }}</span>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ irLabel }}</h1>
            <span class="operation-value">{{ operation.irValue || 0 | formatCurrency(2) }}</span>
          </v-col>
          <template v-if="operation.cide">
            <v-col
              cols="12"
              md="6"
              class="text-left"
            >
              <h1 class="operation-title">{{ cideLabel }}</h1>
              <span class="operation-value">{{
                operation.cideValue || 0 | formatCurrency(2)
              }}</span>
            </v-col>
          </template>
          <v-col
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ tariffLabel }}</h1>
            <span class="operation-value">{{
              operation.exchangeContractCostBrl || 0 | formatCurrency
            }}</span>
          </v-col>
          <v-col
            v-if="calculationTypeConst.CURRENCY_AMOUNT.id == calculationType"
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ $t('simulator.totalLabel') }}</h1>
            <span class="operation-value">{{ operation.totalValue || 0 | formatCurrency(2) }}</span>
          </v-col>
          <v-col
            v-else
            cols="12"
            md="6"
            class="text-left"
          >
            <h1 class="operation-title">{{ $t('simulator.totalLabel') }}</h1>
            <span class="operation-value">
              {{ operation.currency.code }} {{ operation.amount || 0 | formatNumber(2) }}
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// Components
import MoneyField from '@/components/comum/MoneyField';
import SimulatorValueSlider from '@/components/simulator-operation/SimulatorValueSlider.vue';
import CurrencySelect from '../form-operation/CurrencySelect.vue';

// API
import CurrencyApi from '@/api/spread/currency-api';
import ExchangeBankApi from '@/api/exchangeBank/exchange-bank-api';
import OperationNatureApi from '@/api/configuration/operation-nature-api';
import CustomerApi from '@/api/customer/customer-api';

// Models
import CurrencyModel from '@/model/currency-model';
import ExchangeBankModel from '@/model/exchange-bank-model';
import OperationNatureModel from '@/model/operation-nature-model';
import CustomerModel from '@/model/customer-model';
import CustomerExchangeBankModel from '@/model/customer-exchange-bank-model';
import CustomerFiltersModel from '@/model/customer/customer-filters-model';
import ExchangeBankFiltersModel from '@/model/exchangeBank/exchange-bank-filters-model';

// Mixins
import mixinMessage from '@/mixin/mixin-message';
import mixinValidationRules from '@/mixin/mixin-validation-rules';
import mixinAutoCompleteFilters from '@/mixin/mixin-autocomplete-filters';

// Constants
import { OPERATION_TYPE, OPERATION_CALCULATION_TYPE } from '@/constants/general-constants';
import { CUSTOMER_WORKFLOW } from '../../../../common/workflows/customersWorkflow';

// Utils
import numberUtils from '../../../../common/utils/number';
import dateUtils from '../../../../common/utils/date';

export default {
  name: 'SimulatorRemittance',
  mixins: [mixinMessage, mixinValidationRules, mixinAutoCompleteFilters],
  components: { MoneyField, CurrencySelect, SimulatorValueSlider },
  inject: ['appData'],
  data() {
    return {
      operation: this.operationProp,
      currencies: [],
      banks: [],
      natures: [],
      calculationTypeConst: OPERATION_CALCULATION_TYPE,
      customerList: [],
      exchangeBankList: [],
      customerSearchLoading: false,
      customerSearchQuery: '',
      isUpdatingCustomer: false,
      customerApi: new CustomerApi(this.appData.currentUser),
      operationNatureApi: new OperationNatureApi(this.appData.currentUser),
      exchangeBankApi: new ExchangeBankApi(this.appData.currentUser),
      currencyApi: new CurrencyApi(this.appData.currentUser)
    };
  },
  model: {
    prop: 'operationProp',
    event: 'onChange'
  },
  props: {
    operationProp: {
      type: Object,
      default: () => {}
    },
    calculationType: {
      type: [Number, String],
      default: null
    }
  },
  filters: {
    formatCurrency(value, precison) {
      return numberUtils.formatCurrency('BRL', value, precison);
    },
    formatNumber(value) {
      return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value);
    }
  },
  watch: {
    operation() {
      this.emitOperation();
    },
    'operation.bank.id'() {
      this.operation.useUsdExchangeContract = !!this.operation.bank?.useUsdExchangeContract;
      this.operation.exchangeContractCost = this.operation.bank.exchangeContractCost;
    },
    'operation.customer'() {
      if (this.isUpdatingCustomer) return;

      if (!this.operation.customer?.id) {
        this.exchangeBankList = [];
        this.$emit('resetAndUpdateSpread');

        return;
      }

      this.getCustomerExchangeBanks();

      if (!this.operation.customer.spreads?.length) this.getCustomer();
    },
    'operation.currency'() {
      this.$emit('resetAndUpdateSpread');
    },
    customerSearchQuery() {
      clearTimeout(this.customerSearchTimer);

      if (!this.operation.customer || this.customerSearchQuery == this.itemTextCustomers(this.operation.customer)) return;

      if ((this.customerSearchQuery?.length || 0) < 3) {
        this.customerList = [];

        return;
      }

      this.customerSearchTimer = setTimeout(async () => {
        this.customerSearchLoading = true;
        await this.getCustomersList();
        this.customerSearchLoading = false;
      }, 500);
    }
  },
  mounted() {
    this.getBankList();
    this.getNatureList();
    this.getCurrencies();
  },
  computed: {
    bankList() {
      if (this.exchangeBankList.length) return this.exchangeBankList.map((i) => i.bank) || [];

      return (
        this.banks.filter(
          (i) =>
            i.exchangeType.id == OPERATION_TYPE.REMMITANCE.id ||
            i.exchangeType.id == OPERATION_TYPE.BOTH.id
        ) || []
      );
    },
    spreadHint() {
      return (this.operation.spreadMin && this.operation.spreadMax)
        ? `Min: ${this.operation.spreadMin}% - Max: ${this.operation.spreadMax}%`
        : '';
    },
    customerRateHint() {
      return (this.operation.customerRateMin && this.operation.customerRateMax)
        ? `Min: ${this.formatBRL(this.operation.customerRateMin, 5)} - Max: ${this.formatBRL(this.operation.customerRateMax, 5)}`
        : '';
    },
    iofLabel() {
      return this.$t('simulator.iofLabel', { pct: this.operation.iof || 0 });
    },
    irLabel() {
      return this.$t('simulator.irLabel', { pct: this.operation.ir || 0 });
    },
    cideLabel() {
      return this.$t('simulator.cideLabel', { pct: this.operation.cide || 0 });
    },
    tariffLabel() {
      return this.operationProp.useUsdExchangeContract
        ? `${this.$t('simulator.tariffLabel')}(${this.formatUSD(this.operationProp.exchangeContractCost)})`
        : this.$t('simulator.tariffLabel');
    },
    tariffPrefix() {
      return this.operation.useUsdExchangeContract ? 'US$ ' : 'R$ ';
    }
  },
  methods: {
    itemTextCustomers(item) {
      return !item?.name ? item?.companyName + ' - ' + item?.cpfCnpj : item.name + ' - ' + item.cpfCnpj;
    },

    async getCurrencies() {
      if (this.currencies[0]) return;

      try {
        const response = await this.currencyApi.findAll();

        this.currencies = response.data.map((c) => new CurrencyModel(c));
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadCurrencies'));
      }
    },

    async getBankList() {
      if (this.banks[0]) return;

      const filter = new ExchangeBankFiltersModel({ activeOnly: true });

      try {
        const response = await this.exchangeBankApi.findAll(filter);

        this.banks = response.data.map((b) => new ExchangeBankModel(b));
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadBankList'));
      }
    },

    async getNatureList() {
      if (this.natures[0]) return;

      try {
        const response = await this.operationNatureApi.findAll();

        this.natures = response.data.map((n) => new OperationNatureModel(n));
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadNatures'));
      }
    },

    formatBRL(value, precision) {
      return numberUtils.formatCurrency('BRL', value, precision);
    },

    formatUSD(value) {
      return numberUtils.formatCurrency('USD', value);
    },

    emitOperation() {
      this.$emit('onChange', this.operation);
    },

    async getCustomersList() {
      const filters = new CustomerFiltersModel({
        registerStatusList: [CUSTOMER_WORKFLOW.FINALIZADO.id],
        searchText: this.customerSearchQuery
      });

      try {
        const response = await this.customerApi.findAll(filters);

        this.customerList = response.data.map((c) => new CustomerModel(c));
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadCustomers'));
      }
    },

    async getCustomerExchangeBanks() {
      if (!this.operation.customer?.id) return;

      try {
        const response = await this.customerApi.findExchangeBanks(
          this.operation.customer.id,
          this.operation.exchangeType.id,
          true
        );

        this.exchangeBankList = response.data
          .map((c) => new CustomerExchangeBankModel(c))
          .filter((i) => i.limit.id);
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadCustomerBanks'));
      }
    },

    async getCustomer() {
      if (!this.operation.customer?.id) return;

      try {
        this.isUpdatingCustomer = true;

        const response = await this.customerApi.findId(this.operation.customer.id);

        this.operation.customer = new CustomerModel(response.data);
      } catch (error) {
        this.sendErrorMessage(error, this.$t('simulator.errors.loadCustomerData'));
      } finally {
        this.isUpdatingCustomer = false;
      }
    },

    handleClearCustomer() {
      this.operation.customer = null;
      this.customerSearchQuery = '';
    },

    getLimitBank(item) {
      const limit = this.exchangeBankList
        .filter((i) => i.bank.id == item.id)
        .map((i) => i.limit)
        .pop();
      const remainingLimit = limit?.isInOut
        ? (this.operation.exchangeBuy ? limit?.remainingIn : limit?.remainingOut) || 0
        : limit?.remaining || 0;

      return item.useUsdLimit ? this.formatUSD(remainingLimit) : this.formatBRL(remainingLimit);
    },

    getExpireBank(item) {
      const limit = this.exchangeBankList
        .filter((i) => i.bank.id == item.id)
        .map((i) => i.limit)
        .pop();

      return dateUtils.maskDateIso(limit?.expireAt);
    }
  }
};
</script>

<style lang="scss" scoped>
.operation-title {
  text-align: left;
  font-size: 0.9rem;
}

.operation-value {
  font-size: 1.3rem;
  text-align: right;
  color: var(--v-primary-base);
}

.bank-title {
  font-weight: 400;
}

.theme--light .subtitle {
  color: var(--tc-text-2);
  font-size: 12px;
}

.theme--dark .subtitle-dark {
  color: var(--tc-text-3);
  font-size: 12px;
}
</style>
